import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import { WaterContentDryMassesSection } from '.';
import { DateTimeInput, Field, NumericInput, TextInput, TextOutput } from '../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from '../../../../Layout';
import { IWithWorksheetInjectedProps, WorksheetEquipmentDropdown } from '../../../Core';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';
import AirDryingDryMassesSection from './AirDryingDryMassesSection';

const WaterContentMethodBSectionBase: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const showTimeInOven = useSelector(
    pipe(createDryMassEntryOptionSelector(createWorksheetSelector!), (v) => v !== 'Never')
  );

  return (
    <SectionGroup heading="Water Content">
      <NamePrefixModifier appendNamePrefix="AirDrying">
        {/* Equipment for air drying */}
        <ListFieldSection>
          <WorksheetBalanceFieldSet label="Balance" name="Balance" />
        </ListFieldSection>
        {/* Wet masses */}
        <ListFieldSection>
          <Field input={<NumericInput />} label="Container Mass" name="TareMass" />
          <Field input={<NumericInput />} label="Container and Material Wet Mass" name="TareAndWetMass" />
          <Field input={<TextOutput />} label="Material Wet Mass" name="WetMass" />
        </ListFieldSection>
      </NamePrefixModifier>

      {/* Air dried masses */}
      <AirDryingDryMassesSection />
      <ListFieldSection>
        <Field
          input={<TextOutput />}
          label="Container and Material Air-dried Mass"
          name="AirDrying.ConstantTareAndDryMass"
        />
      </ListFieldSection>

      <NamePrefixModifier appendNamePrefix="OvenDrying">
        {/* Equipment for oven drying  - note: the same balance is used as for the air drying */}
        <ListFieldSection>
          <NamePrefixModifier appendNamePrefix="Equipment">
            <Field input={<WorksheetEquipmentDropdown />} name="Oven" equipmentType="oven" />
            <Field input={<NumericInput />} name="DryingTemperature" />
          </NamePrefixModifier>
        </ListFieldSection>
      </NamePrefixModifier>

      {/* Wet masses */}
      {/* We need to redirect messages from another path which is why we don't prefix paths here */}
      <ListFieldSection>
        <Field input={<TextInput />} name="OvenDrying.DryingTray.ContainerLabel" />
        <Field
          input={<NumericInput />}
          name="OvenDrying.DryingTray.ContainerMass"
          additionalMessagePaths={['Combustion.TareMass']}
        />
        <Field
          input={<NumericInput />}
          label="Tare and Material Air-dried Mass"
          name="OvenDrying.DryingTray.WetSoilAndContainerMass"
        />
        <Field input={<TextOutput />} label="Material Air-dried Mass" name="OvenDrying.DryingTray.WetSoilMass" />
        {showTimeInOven && <Field input={<DateTimeInput />} name="OvenDrying.DryingTray.DateTimePlacedInOvenLocal" />}
      </ListFieldSection>

      <NamePrefixModifier appendNamePrefix="OvenDrying">
        <WaterContentDryMassesSection />
        {/* Results */}
        <ListFieldSection>
          <Field emph input={<TextOutput />} name="Results.MoistureContentPercent" />
        </ListFieldSection>
      </NamePrefixModifier>
    </SectionGroup>
  );
};

const WaterContentMethodBSection = withInjectedProps(WaterContentMethodBSectionBase);
export { WaterContentMethodBSection };
export default WaterContentMethodBSection;
